import { dayjs } from '@shared/utils';

import { type ExamEventCreationFormType } from './schema';

export function getExamTime(examDate: Date, startTime: Date, endTime: Date) {
  const startedAt = dayjs(examDate)
    .set('hour', startTime.getHours())
    .set('minute', startTime.getMinutes())
    .startOf('minute')
    .toDate();
  const endedAt = dayjs(examDate)
    .set('hour', endTime.getHours())
    .set('minute', endTime.getMinutes())
    .startOf('minute')
    .toDate();

  return { examStartTime: startedAt, examEndTime: endedAt };
}

export function getDefaultValues() {
  const defaultValues: ExamEventCreationFormType = {
    examEventName: '',
    examType: undefined,
    registrationType: undefined,
    examDate: {
      date: null,
      startTime: null,
      endTime: null,
    },
    sessions: [],
    eventEndDate: undefined,
    eventStartDate: undefined,
    location: {
      locationName: undefined,
      province: undefined,
      room: {},
    },
    mainProctors: undefined,
    groupType: null,
    groupCode: '',
  };

  return defaultValues;
}
